<template>
    <div class="rfq">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>订单管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>订单</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" :disabled="loading" size="mini">
                    <el-form-item label="公司名称" prop="companyIds" label-width="70px">
                        <el-select multiple filterable collapse-tags clearable size="mini" mul
                            v-model="searchForm.companyIds" placeholder="公司名称" style="width: 150px">
                            <el-option v-for="item in companys" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户邮箱" label-width="70px">
                        <el-input v-model="searchForm.email" placeholder="用户邮箱" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="收货人" label-width="70px">
                        <el-input v-model="searchForm.consignee" placeholder="收货人" size="mini" clearable
                            style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="收货人手机" label-width="85px">
                        <el-input v-model="searchForm.mobile" placeholder="收货人手机" size="mini" clearable
                            style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="收货地址" label-width="70px">
                        <el-input v-model="searchForm.address" placeholder="收货地址" size="mini" clearable
                            style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="下单日期">
                        <el-date-picker size="mini" v-model="searchForm.timeDate" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions" clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态" label-width="70px">
                        <el-select v-model="searchForm.status" placeholder="状态" size="mini" clearable multiple style="width: 150px">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="待下单" value="0"></el-option>
                            <el-option label="已下单" value="2"></el-option>
                            <el-option label="已发货" value="3"></el-option>
                            <el-option label="已收货" value="4"></el-option>
                            <el-option label="已取消" value="5"></el-option>
                            <el-option label="已驳回" value="6"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否结算" label-width="70px">
                        <el-select v-model="searchForm.settlement" placeholder="是否结算" size="mini" clearable style="width: 150px">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未结算" value="0"></el-option>
                            <el-option label="已结算" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="需求所属月份" label-width="100px">
                        <el-input v-model="searchForm.demandMonth" placeholder="需求所属月份" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="ID" label-width="70px">
                        <el-input v-model="searchForm.id" placeholder="订单ID" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="订单编号" label-width="70px">
                        <el-input v-model="searchForm.orderNo" placeholder="订单编号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <RightToolBar :showSearch="showSearch"  @reDrawTable="reDrawTable"
                                      :columns="dropCol" ></RightToolBar>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    ref="dataTable"
                    :key = "updateTable"
                    row-key="id"
                    :data="tableData"
                    v-loading="loading"
                    style="width: 100%"
                    stripe
                    size="mini"
                    :height="tableConfig.height"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55" fixed />
                    <el-table-column min-width="180" width="auto"
                                     class-name="drag"
                                     v-if="dropCol[0].isShow"
                                     :key="dropCol[0].id"
                                     :prop="dropCol[0].prop"
                                     :label="dropCol[0].label"/>
                    <el-table-column min-width="180" width="auto"
                                     class-name="drag"
                                     v-if="dropCol[1].isShow"
                                     :key="dropCol[1].id"
                                     :prop="dropCol[1].prop"
                                     :label="dropCol[1].label"/>
                    <el-table-column min-width="180" width="auto"
                                     class-name="drag"
                                     v-if="dropCol[2].isShow"
                                     :key="dropCol[2].id"
                                     :prop="dropCol[2].prop"
                                     :label="dropCol[2].label"/>
                    <el-table-column min-width="180" width="auto"
                                     class-name="drag"
                                     v-if="dropCol[3].isShow"
                                     :key="dropCol[3].id"
                                     :prop="dropCol[3].prop"
                                     :label="dropCol[3].label"/>
                    <el-table-column min-width="180" width="auto"
                                     class-name="drag"
                                     v-if="dropCol[4].isShow"
                                     :key="dropCol[4].id"
                                     :prop="dropCol[4].prop"
                                     :label="dropCol[4].label">
                    </el-table-column>
                    <el-table-column min-width="200" width="auto"
                                     class-name="drag"
                                     v-if="dropCol[5].isShow"
                                     :key="dropCol[5].id"
                                     :prop="dropCol[5].prop"
                                     :label="dropCol[5].label">
                    </el-table-column>
                    <el-table-column min-width="120" width="auto"
                                     class-name="drag"
                                     v-if="dropCol[6].isShow"
                                     :key="dropCol[6].id"
                                     :prop="dropCol[6].prop"
                                     :label="dropCol[6].label">
                    </el-table-column>
                    <el-table-column min-width="120" width="auto"
                                     class-name="drag"
                                     v-if="dropCol[7].isShow"
                                     :key="dropCol[7].id"
                                     :prop="dropCol[7].prop"
                                     :label="dropCol[7].label">
                    </el-table-column>
                    <el-table-column min-width="300" width="auto"
                                     class-name="drag"
                                     v-if="dropCol[8].isShow"
                                     :key="dropCol[8].id"
                                     :prop="dropCol[8].prop"
                                     :label="dropCol[8].label">
                    </el-table-column>
                    <el-table-column min-width="150" width="auto" align="center"
                                     class-name="drag"
                                     v-if="dropCol[9].isShow"
                                     :key="dropCol[9].id"
                                     :prop="dropCol[9].prop"
                                     :label="dropCol[9].label">
                    </el-table-column>
                    <el-table-column min-width="150" width="auto" align="center"
                                     class-name="drag"
                                     v-if="dropCol[10].isShow"
                                     :key="dropCol[10].id"
                                     :prop="dropCol[10].prop"
                                     :label="dropCol[10].label">
                    </el-table-column>
                    <el-table-column min-width="150" width="auto" align="center"
                                     class-name="drag"
                                     v-if="dropCol[11].isShow"
                                     :key="dropCol[11].id"
                                     :prop="dropCol[11].prop"
                                     :label="dropCol[11].label">
                    </el-table-column>
                    <el-table-column min-width="150" width="auto" align="center"
                                     class-name="drag"
                                     v-if="dropCol[12].isShow"
                                     :key="dropCol[12].id"
                                     :prop="dropCol[12].prop"
                                     :label="dropCol[12].label">
                    </el-table-column>
                    <el-table-column min-width="150" width="auto" align="center"
                                     class-name="drag"
                                     v-if="dropCol[13].isShow"
                                     :key="dropCol[13].id"
                                     :prop="dropCol[13].prop"
                                     :label="dropCol[13].label">
                    </el-table-column>
                    <el-table-column width="200" align="center"
                                     class-name="drag"
                                     v-if="dropCol[14].isShow"
                                     :key="dropCol[14].id"
                                     :prop="dropCol[14].prop"
                                     :label="dropCol[14].label">
                    </el-table-column>
                    <el-table-column  width="200" align="center"
                                      class-name="drag"
                                      v-if="dropCol[15].isShow"
                                      :key="dropCol[15].id"
                                      :prop="dropCol[15].prop"
                                      :label="dropCol[15].label">
                    </el-table-column>
                    <el-table-column fixed="right" width="100" align="center"
                                     v-if="dropCol[16].isShow"
                                     :key="dropCol[16].id"
                                     :prop="dropCol[16].prop"
                                     :label="dropCol[16].label">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 0" size="mini">待下单</el-tag>
                            <el-tag v-if="scope.row.status == 1" size="mini">预下单</el-tag>
                            <el-tag v-if="scope.row.status == 2" size="mini">已下单</el-tag>
                            <el-tag v-if="scope.row.status == 3" size="mini">已发货</el-tag>
                            <el-tag v-if="scope.row.status == 4" size="mini">已收货</el-tag>
                            <el-tag v-if="scope.row.status == 5" size="mini">已取消</el-tag>
                            <el-tag v-if="scope.row.status == 6" size="mini">已驳回</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="100" align="center"
                                     v-if="dropCol[17].isShow"
                                     :key="dropCol[17].id"
                                     :prop="dropCol[17].prop"
                                     :label="dropCol[17].label">
                        <template slot-scope="scope">
                            <el-tag type="info" v-if="scope.row.isInvoice" size="mini">已结算</el-tag>
                            <el-tag v-if="!scope.row.isInvoice" size="mini">未结算</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column width="160" align="right" fixed="right"
                                     v-if="dropCol[18].isShow"
                                     :key="dropCol[18].id"
                                     :prop="dropCol[18].prop"
                                     :label="dropCol[18].label">
                        <template slot="header" slot-scope="header">
                            <!--                            <el-button type="primary" size="mini" @click="exportOrderDialog">导出</el-button>-->
                            <!-- <el-button type="primary" size="mini" @click="exportPMS()">导出PMS订单</el-button> -->
                            <el-button type="primary" size="mini" @click="settlement()">结算</el-button>
                            <el-dropdown style="margin-left: 8px;" @command="exportOrderDialogNew">
                                <el-button type="primary" size="mini">
                                    导出<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="all">导出全部</el-dropdown-item>
                                    <el-dropdown-item command="selected">导出已选</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <!-- <el-button type="primary" size="mini" @click="exportOrderDialogNew()">导出</el-button> -->
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleToReviewDetail(scope.row)">详情</el-button>
                            <el-divider direction="vertical"></el-divider>
                            <el-button type="text" size="mini" @click="handleToContract(scope.row)">订单</el-button>
                            <el-divider direction="vertical"></el-divider>

                            <el-dropdown size="mini" style="margin-left: 10px;">
                                <div style="">
                                     <span class="el-dropdown-link" style="font-size: 12px;vertical-align: middle;line-height: 28px;" >
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                  </span>
                                </div>

                                <el-dropdown-menu slot="dropdown">

                                    <el-dropdown-item>
                                        <el-button type="text" v-if="scope.row.status == 1" size="mini" @click="orderIt(scope.row)" style="width: 100%;text-align: left;">下单</el-button>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <el-button type="text" size="mini" @click="handleToDeliver(scope.row)" style="width: 100%;text-align: left;">签收单</el-button>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <el-button type="text" size="mini" @click="handleCancel(scope.row)" style="width: 100%;text-align: left; color: red">强制取消</el-button>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <!-- <el-button type="text" v-if="scope.row.status != 1"  size="mini" @click="handleToDeliver(scope.row)">签收单</el-button> -->


                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination background layout="sizes, prev, pager, next" v-if="total>0" :total="total"
                        :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :current-page="currentPage" @size-change="handleSizeChange"
                        @current-change="onPageChange" @prev-click="onPageChange" @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <!-- <el-dialog title="加入订单" :visible.sync="addOrderVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="addOrderForm" :model="addOrderForm" :rules="rules" label-width="100px">
                <el-form-item label="订单编号" prop="orderBatch">
                    <el-input v-model="addOrderForm.orderBatch" placeholder="请输入订单编号" size="mini" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addOrderVisible = false">取 消</el-button>
                <el-button type="primary" @click="addOrder">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="导出订单" :visible.sync="exportOrderVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="exportOrderForm" :model="exportOrderForm" :rules="rules" label-width="100px">
                <el-form-item label="订单编号" prop="orderBatch">
                    <el-input v-model="exportOrderForm.orderBatch" placeholder="请输入订单编号" size="mini" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="exportOrderVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportOrder">确 定</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>
<script>
import { downloadByPost, convertRes2Blob } from '../../utils/download.js';
import Sortable from "sortablejs";
import RightToolBar from "../../components/RightToolBar";
import { KeepAliveTableMixins } from '../../mixin/KeepAliveTable';
const HEIGHT_OFFSET = 118;
export default {
    mixins: [KeepAliveTableMixins],
    components:{RightToolBar},
    data() {
        return {
            showSearch:false,
            updateTable:"saleTable",

            dropCol: [
                {id:"0",label: '公司',prop: 'companyName',isShow: true},
                {id:"1",label: '需求所属月份',prop: 'demandMonth',isShow: true},
                {id:"2",label: '协议编号',prop: 'agreementNumber',isShow: true},
                {id:"3",label: '发票抬头',prop: 'invoiceCompanyName',isShow: true},
                {id:"4",label: '用户邮箱',prop: 'email',isShow: true},
                {id:"5",label: '订单编号',prop: 'orderNo',isShow: true},
                {id:"6",label: '收货人',prop: 'consignee',isShow: true},
                {id:"7",label: '收货人手机', prop: 'mobile',isShow: true},
                {id:"8",label: '收货地址',prop: 'address',isShow: true},
                {id:"9",label: '商品种类数量',prop: 'itemNum',isShow: true},
                {id:"10",label: '未税总价(元)',prop: 'totalUntaxedPrice',isShow: true},
                {id:"11",label: '含税总价(元)',prop: 'totalPrice',isShow: true},
                {id:"12",label: '运费(元)',prop: 'freight',isShow: true},
                {id:"13",label: '总价(元)',prop: 'total',isShow: true},
                {id:"14",label: '创建时间',prop: 'createTime',isShow: true},
                {id:"15",label: '下单时间',prop: 'orderTime',isShow: true},
                {id:"16",label: '状态',prop: 'status',isShow: true },
                {id:"17",label: '结算',prop: 'isInvoice',isShow: true },
                {id:"18", label: '操作', prop: 'op', isShow: true }


            ],
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            reviewVisible: false,
            companys: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            searchForm: {
                companyIds: [],
                email: "",
                consignee: "",
                address: "",
                orderBatch: "",
                status: "",
                settlement: "",
                timeDate: "",
                demandMonth: "",
                orderNo: "",
                id: "",
            },
            searchFormStash: {},
            loading: false,
            total: 0,
            pageSize: 10,
            pageSizes: [10, 20, 50, 100],
            currentPage: 1,
            tableData: [],
            // addOrderVisible: false,
            // addOrderForm: {
            //     id: "",
            //     orderBatch: "",
            // },
            // exportOrderVisible: false,
            // exportOrderForm: {
            //     orderBatch: "",
            // },
            // orderForm: {
            //     orderBatch: "",
            // },
            selectData: [],//选中的数据
            rules: {
                orderBatch: [
                    { required: true, message: '请输入订单编号', trigger: 'blur' }
                ],
            },
            scrollTop: 0,
            scrollLeft: 0,
        }
    },
    methods: {
        onSearch() {
            this.loading = true;
            this.selectData = [];
            let _this = this;
            let cond = { ...this.searchForm };
            if (!this.searchForm.status) {
                cond['status'] = undefined;
            }
            if (!this.searchForm.companyIds) {
                cond['companyIds'] = [];
            }
            if (this.searchForm.timeDate != "" && this.searchForm.timeDate != null) {
                cond["startTime"] = this.searchForm.timeDate[0];
                cond["endTime"] = this.searchForm.timeDate[1];
            }
            this.searchFormStash = {...cond};
            this.$axios.post("/admin/rfq/orderList", {
                cond,
                page: this.currentPage - 1,size:this.pageSize,
            }).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function () {
            });
        },
        doSearch() {
            this.currentPage=1;
            this.onSearch();
        },
        showExportOrderDialog() {
            this.exportOrderForm.orderBatch = "";
            this.exportOrderVisible = true;
        },
        exportOrder() {
            const that = this;
            this.$refs.exportOrderForm.validate(valid => {
                if (valid) {
                    downloadByPost({
                        axios: that.$axios,
                        url: "/admin/rfq/exportCustomerOrderDetail",
                        data: that.exportOrderForm,
                        success: response => {
                            convertRes2Blob(response);
                        },
                    });
                }
            });
        },

        orderIt(row) {//把订单状态从预下单改为下单

            //确定通过abc提交的总价￥123,456,78的订单吗?

            const that = this;

            this.$confirm('确定通过' + '【' + row.consignee + '】提交的总价【￥' + row.totalPrice + '】的订单吗？', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {

                this.$axios.post("/admin/rfq/orderIt", row.id)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {

                            that.reviewVisible = false;
                            if (resp.data == true) {//
                                that.$notify({
                                    title: '成功',
                                    message: '已下单',
                                    type: 'success'
                                });
                                that.onSearch();
                            } else {
                                that.$notify({
                                    title: '提示',
                                    message: '下单失败',
                                    type: 'success'
                                });

                            }

                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            });


        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleToReviewDetail(row) {

            this.$router.push({
                name: "orderReviewDetail", params:{title:"订单详情",info:row.id,id: row.id}
            });

        },
        handleToContract(row) {
            let showBtn = (row.status == 1);

            this.$router.push({
                name: "orderContract", params: {title:"订单详情",hide:true,
                    from: "rfq", orderId: row.id,
                    name: row.consignee, totalPrice: row.totalPrice, showBtn: showBtn
                }
            })
        },
        // exportOrderDialog() {
        //     if (this.selectData.length == 0) {
        //         this.$message({
        //             type: 'info',
        //             message: '请选择要导出的订单',
        //             duration: 2000
        //         });
        //         return;
        //     }
        //     const that = this;
        //     let arr = [];
        //     let val = this.selectData;
        //     if (val.length > 0) {
        //         for (let i = 0; i < val.length; i++) {
        //             arr.push(val[i].id);
        //         }
        //         downloadByPost({
        //             axios: that.$axios,
        //             url: "/admin/rfq/exportOrderDetail",
        //             data: arr,
        //             success: response => {
        //                 convertRes2Blob(response);
        //             },
        //         });
        //     }
        // },
        exportOrderDialogNew(command) {
            let data = {};
            switch(command) {
                case 'all': {
                    data = {cond: {...this.searchFormStash}};
                    break;
                }
                case 'selected': {
                    if (this.selectData.length == 0) {
                        this.$message({
                            type: 'error',
                            message: '请选择要导出的订单',
                            duration: 2000
                        });
                        return;
                    }
                    data = {orderIds: this.selectData.map(it => it.id)};
                    // const that = this;
                    // let arr = [];
                    // let val = this.selectData;
                    // if (val.length > 0) {
                    //     for (let i = 0; i < val.length; i++) {
                    //         arr.push(val[i].id);
                    //     }
                    // }
                    break;
                }
            }
            this.loading = true
            downloadByPost({
                axios: this.$axios,
                url: "/admin/easypoi/adminOrder",
                data,
                success: response => {
                    convertRes2Blob(response);
                },
                complete: () => {
                    this.loading = false;
                }
            });
        },
        exportPMS() {
            if (this.selectData.length == 0) {
                this.$message({
                    type: 'info',
                    message: '请选择要导出的订单',
                    duration: 2000
                });
                return;
            }
            const that = this;
            let arr = [];
            let val = this.selectData;
            if (val.length > 0) {
                for (let i = 0; i < val.length; i++) {
                    arr.push(val[i].id);
                }
                downloadByPost({
                    axios: that.$axios,
                    url: "/admin/easypoi/pms",
                    data: arr,
                    success: response => {
                        convertRes2Blob(response);
                    },
                });
            }

        },
        handleSelectionChange(val) {
            this.selectData = val;

            //this.$refs.dataTable.

        },
        loadCompanys() {
            let _this = this
            this.$axios.post("/admin/company/customerCompanies"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.companys = resp.data;
                }

            });

        },
        settlement() {
            const that = this;
            if (this.selectData.length == 0) {
                this.$message({
                    type: 'info',
                    message: '请选择要结算的订单',
                    duration: 2000
                });
                return;
            }
            const invocieCompanies = new Set(this.selectData.map(it => it['invoiceCompanyName']))
            if(invocieCompanies.size>1) {
                this.$notify.error({
                    title: '错误',
                    message: '请选择相同发票抬头的订单'
                });
                return;
            }
            this.loading = true;
            this.$axios.post("/admin/invoice/saveSettlementForAdmin", { orderIds: this.selectData.map(it => it['id']) })
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '数据保存成功',
                            type: 'success'
                        });
                        that.fetchData();
                        that.reviewVisible = false;
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                }).finally(() => {
                    that.onSearch();
                    that.loading = false;
                });
        },
        handleToDeliver(row) {
            this.viewDeliverVisible = true;
            this.$router.push({name: "deliver", params: {from: "order", orderId: row.id,title:"签收单",hide:true}});
        },
        handleCancel(row) {
            const that = this;
            that.$confirm('<div style="color: red">！！！取消信息不会通知供应商，请线下通知供应商！！！</div><div>确定强制取消' + '【' + row.consignee + '】提交的总价【￥' + row.totalPrice + '】的订单【' + row.orderNo + '】吗？</div>', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
            }).then(() => {
                that.$axios.post("/admin/product/order/forceCancel", { id: row.id }).then(function (response) {
                    const resp = response.data;
                    if (resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '订单已取消',
                            type: 'success'
                        });
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                }).finally(() => {
                    that.onSearch();
                    that.loading = false;
                });
            });
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
        //重绘表格
        reDrawTable() {

            this.updateTable = "orderTable"+Math.random();
            this.$nextTick(()=>{
                this.columnDrop();
            });

        },
        //列拖拽
        columnDrop(){
            try{
                //const wrapperTr = this.$refs.purchaseTable.$el.querySelector('.el-table__header-wrapper tr');
                const wrapperTr = document.querySelector('.el-table__header-wrapper tr');
                let oldLabel;
                let newLabel;
                let oldIndex;
                let newIndex;
                let count=0;
                const that=this;
                this.sortable = Sortable.create(wrapperTr, {
                    animation: 180,
                    delay: 30,
                    draggable:".drag",
                    onEnd: evt => {

                        oldLabel=this.$refs.dataTable.columns[evt.oldIndex].property;
                        newLabel=this.$refs.dataTable.columns[evt.newIndex].property;
                        for (let i=0;i<that.dropCol.length;i++){
                            if (that.dropCol[i].prop!=undefined&&that.dropCol[i].prop==newLabel)
                                newIndex=i;

                        }

                        for (let j=0;j<that.dropCol.length;j++){
                            if (that.dropCol[j].prop!=undefined&&that.dropCol[j].prop==oldLabel)
                                oldIndex=j;
                        }

                        const oldItem = this.dropCol[oldIndex];
                        this.dropCol.splice(oldIndex, 1);
                        this.dropCol.splice(newIndex, 0, oldItem);

                        this.dropCol.forEach((item)=>{
                            if(item.prop==newLabel||item.prop==oldLabel){
                                item.id=new Date().getTime() + (++count)+"";
                                //console.log(JSON.stringify(this.dropCol));// eslint-disable-line
                            }
                        })



                    },
                });
            }catch (e) {
                console.log(e);// eslint-disable-line
            }
        },

    },
    created() {
        this.onSearch();
        this.loadCompanys();
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
        this.columnDrop();
    },
    activated() {
        // setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        // }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    },
}
</script>
<style></style>
